if (!customElements.get('sub-header')) {
  customElements.define(
    'sub-header',
    class SubHeader extends HTMLElement {
      static SCROLL_THRESHOLD = 50;
      static SCROLL_TOP_ZONE_MOBILE  = 56;
      static SCROLL_TOP_ZONE_DESKTOP = 68;

      constructor() {
        super();
        this._lastScrollY   = 0;
        this._ticking       = false;
        this._rafId         = null;
        this._handleScroll  = this._onScroll.bind(this);
        this._handleKeydown = this._onKeydown.bind(this);
      }

      connectedCallback() {
        this._lastScrollY = window.scrollY;
        this.list = this.querySelector('.js-sub-header-list');
        this.list?.addEventListener('keydown', this._handleKeydown);
        this.stickyType = document.querySelector('sticky-header')?.dataset.stickyType ?? 'none';

        if (this.stickyType !== 'none') {
          this.classList.add('fixed');
          window.addEventListener('scroll', this._handleScroll, { passive: true });
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._handleScroll);
        this.list?.removeEventListener('keydown', this._handleKeydown);
        cancelAnimationFrame(this._rafId);
        this._ticking = false;
        this._rafId   = null;
      }

      _onScroll() {
        if (this._ticking) return;
        this._rafId = requestAnimationFrame(() => {
          this._handlePageScroll();
          this._ticking = false;
        });
        this._ticking = true;
      }

      _handlePageScroll() {
        const currentScrollY = window.scrollY;
        const scrollDiff     = currentScrollY - this._lastScrollY;

        const topZone = window.innerWidth >= 1024
          ? SubHeader.SCROLL_TOP_ZONE_DESKTOP
          : SubHeader.SCROLL_TOP_ZONE_MOBILE;

        if (currentScrollY < topZone) {
          this._show();
          this._lastScrollY = currentScrollY;
          return;
        }

        if (Math.abs(scrollDiff) < SubHeader.SCROLL_THRESHOLD) return;

        if (scrollDiff > 0) {
          this._hide();
        } else {
          this._show();
        }

        this._lastScrollY = currentScrollY;
      }

      _show() {
        this.classList.remove('sub-header--hidden');
        this.removeAttribute('inert');
      }

      _hide() {
        this.classList.add('sub-header--hidden');
        this.setAttribute('inert', '');
      }

      _onKeydown(e) {
        if (!this.list) return;

        const links        = Array.from(this.list.querySelectorAll('a'));
        const currentIndex = links.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        const lastIndex = links.length - 1;
        const keyMap    = {
          ArrowRight: links[currentIndex === lastIndex ? 0 : currentIndex + 1],
          ArrowLeft:  links[currentIndex === 0 ? lastIndex : currentIndex - 1],
          Home:       links[0],
          End:        links[lastIndex],
        };

        if (keyMap[e.key]) {
          e.preventDefault();
          keyMap[e.key].focus();
        }
      }
    }
  );
}